__turbopack_context__.v({
  "container": "Row-module-scss-module__TidEcW__container",
  "content": "Row-module-scss-module__TidEcW__content",
  "fullWidth": "Row-module-scss-module__TidEcW__fullWidth",
  "image": "Row-module-scss-module__TidEcW__image",
  "imageContainer": "Row-module-scss-module__TidEcW__imageContainer",
});
